import { Hero } from "@/components/home/Hero";
import { TripsSection } from "@/components/home/TripsSection";
import { HowItWorks } from "@/components/home/HowItWorks";
import { ScheduleTeaser } from "@/components/home/ScheduleTeaser";

export default function Home() {
  return (
    <>
      <Hero />
      <TripsSection />
      <HowItWorks />
      <ScheduleTeaser />
    </>
  );
}
